import { confirmTaxIdFieldConfig, taxIdFieldConfig } from "./_common";

export const unitedStatesFields = {
  usSsn: taxIdFieldConfig("US", "usSsn"),
  usConfirmSsn: confirmTaxIdFieldConfig("US", "usSsn"),
};
